<div>

    <bko-tilbake-link class="content-wrapper"></bko-tilbake-link>
    <bko-beskrivelse [tiltak]="tiltak"></bko-beskrivelse>
    <bko-tilskudd [tilskudd]="tiltak.tilskudd ?? []"></bko-tilskudd>

</div>
